import React, { useEffect, useState } from "react";
import { ListItem, ListItemIcon, ListItemText, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import Checkbox from "@mui/material/Checkbox";

const GroupItemListPopup = (props) => {
    const { t } = useTranslation("translation");
    const [groupItemListData, setGroupItemListData] = useState(props.groupItemListData);

    const [searchInput, setSearchInput] = useState("");
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setSearchText(searchInput);
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchInput]);

    const handleToggle = (index) => () => {
        const updatedGroupItemListData = [...groupItemListData];
        updatedGroupItemListData[index] = {
            ...updatedGroupItemListData[index],
            checked: !updatedGroupItemListData[index].checked
        };
        setGroupItemListData(updatedGroupItemListData);
    };

    const filteredData = groupItemListData.filter(item =>
        item.name.toLowerCase().includes(searchText.toLowerCase())
    );

    return (
        <Container id="gilp_Container">
            <Dialog id="gilp_Dialog" open={props.open} onClose={props.onCancel} fullWidth maxWidth="xs">
                <DialogTitle id="gilp_DialogTitle">{t("SelectInstruction")}</DialogTitle>
                <TextField
                    id="gilp_SearchInput"
                    placeholder={t("Search")}
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                />

                <DialogContent id="gilp_DialogContent" dividers={true}>
                    {filteredData.map((groupItem, index) => (
                        <ListItem
                            id={`gilp_ListItem_${index}`}
                            button
                            key={groupItem.name}
                            onClick={handleToggle(index)}
                            disablePadding
                        >
                            <ListItemIcon id={`gilp_ListItemIcon_${index}`}>
                                <Checkbox
                                    id={`gilp_Checkbox_${index}`}
                                    edge="start"
                                    checked={groupItem.checked}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText id={`gilp_ListItemText_${index}`} primary={groupItem.name} />
                        </ListItem>
                    ))}
                </DialogContent>
                <DialogActions id="gilp_DialogActions">
                    <Button id="gilp_b" onClick={props.onCancel} color="primary">
                        {t("Cancel")}
                    </Button>
                    <Button id="gilp_b_1" onClick={() => props.onConfirm(groupItemListData)} color="primary">
                        {t("Confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default GroupItemListPopup;
